<template>
  <div class="block" id="map_log_data">
    <h2 style="font-size: 24px">
      日志查询
      <el-tooltip placement="right">
        <div slot="content">仅支持查询7天内的数据</div>
        <img class="img-help" src="@/assets/images/icon_help.png" />
      </el-tooltip>
    </h2>
    <title-name
      title=" "
      :btn="btnOptions"
      @selectChange="selectChange"
    ></title-name>
    <div class="content-inner-wrap">
      <div class="data-filter">
        <span class="mgr25">选择日期</span>
        <el-date-picker
          v-model="query.selectDate[0]"
          type="datetime"
          :pickerOptions="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        >
        </el-date-picker>
        <span style="margin: 0 10px">~</span>
        <el-date-picker
          v-model="query.selectDate[1]"
          type="datetime"
          disabled
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-button @click="handleSearch" class="search_btn" type="info">
          查找
        </el-button>
        <span>
          <el-radio-group v-model="dayNum" size="medium" @change="clickDate">
            <el-radio-button label="2">近2天</el-radio-button>
            <el-radio-button label="7">近7天</el-radio-button>
          </el-radio-group>
        </span>
      </div>
    </div>
    <el-dialog title="ss_lua_error日志" :visible.sync="luaErrorLogDialog" width="68%">
      <span class="download-wrap" @click="exportFn">
        <img src="@/assets/images/icon_export.png" />
        <span>导出数据</span>
      </span>
      <div class="data-table" v-loading="luaErrorLogLoading">
        <el-table id="ssLuaErrLog" class="data-box" border :data="luaErrorLogList" stripe>
          <el-table-column
            scope="row"
            label="id"
            prop="aid"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            scope="row"
            label="日志内容"
            prop="err_detail"
            align="center"
          >
            <template slot-scope="scope">
              <vue-ellipsis
                :visible-line="3"
                :text="scope.row.err_detail"
                reflow-on-resize
                :ellipsis="luaErrorLogList[scope.$index].ellipsis"
                :on-ellipsis-click="
                  () => {
                    luaErrorLogList[scope.$index].ellipsis = false;
                  }
                "
                :on-unellipsis-click="
                  () => {
                    luaErrorLogList[scope.$index].ellipsis = true;
                  }
                "
              >
                <template slot="ellipsisNode">
                  <el-link
                    type="primary"
                    :underline="false"
                    style="margin-left: 16px"
                    >展开</el-link
                  >
                </template>
                <template slot="unellipsisNode">
                  <el-link
                    type="primary"
                    style="margin-left: 16px"
                    :underline="false"
                  >
                    收起</el-link
                  >
                </template>
              </vue-ellipsis>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="img-no">
              <img
                class="img-no-data"
                src="../../../assets/images/img_table_no_data.png"
              />
              <div class="noCart">暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <template #footer>
        <span>
          <el-button @click="luaErrorLogDialog = false">Cancel</el-button>
          <el-button type="primary" @click="luaErrorLogDialog = false">OK</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog title="通用服务器日志" :visible.sync="studioLogDialog" width="68%">
      <div v-loading="studioLogLoading">
        <div class="btnGroup">
          <span class="mgr25">Uin</span>
          <el-input
            v-model="suin"
            class="mgr25"
            style="width: 200px"
            placeholder="请输入uin"
          />
          <el-button type="primary" @click="handleSearchStudioLog">查询</el-button>
        </div>
        <div class="data-table">
          <el-table id="studioLog" class="data-box" border :data="studioLogList" stripe>
            <el-table-column
              label="主机"
              prop="hostname"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="文件名"
              prop="filename"
              align="center"
            ></el-table-column>
            <el-table-column
              label="创建时间"
              prop="timestamp"
              width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="下载"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="sdudioDownload(scope.row)">下载</el-button>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="img-no">
                <img
                  class="img-no-data"
                  src="../../../assets/images/img_table_no_data.png"
                />
                <div class="noCart">暂无数据</div>
              </div>
            </template>
          </el-table>
          <br>
          <div style="text-align: center;">
            <el-pagination
              background
              @current-change="CurrentChange"
              :current-page="studioLogPageInfo.page"
              :page-size="studioLogPageInfo.limit"
              layout="prev, pager, next,jumper"
              :total="studioLogPageInfo.total"
              hide-on-single-page
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <template #footer>
        <span>
          <el-button @click="studioLogDialog = false">Cancel</el-button>
          <el-button type="primary" @click="studioLogDialog = false">OK</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { getSsLuaErrorData, getStudioMapLogFiles, studioMapPreDownload, studioMapDownload } from '@/api/charts';
import titleName from './title-btn.vue';
import { formatDate, htmlToExcel } from '@/utils';

// const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 48 * 60 * 60 * 1000;
export default {
  components: {
    titleName,
  },
  data() {
    return {
      luaErrorLogLoading: false,
      luaErrorLogDialog: false,
      luaErrorLogList: [],
      studioLogLoading: false,
      studioLogDialog: false,
      studioLogList: [],
      studioLogPageInfo: {
        page: 1,
        limit: 10,
        total: 0
      },
      suin: '',
      dayNum: 2,
      appId: '',
      mapId: '',
      productState: {
        type: '1', // 1查询ss_lua_error 2查询通用服务器日志
      },
      query: {
        selectDate: [],
      },
      btnOptions: [{ label: '查询ss_lua_error', id: '1' }, { label: '查询通用服务器日志', id: '2' }],
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 24 * 3600 * 1000 * 14 ||
            time.getTime() > Date.now()
          );
        },
      },
    };
  },
  created() {
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.query.selectDate = [
      formatDate(currTime - ONE_DAY),
      formatDate(new Date()),
    ];
    this.mapId = this.$route.query.id;
  },
  methods: {
    handleSearch() {
      console.log('handleSearch', this.productState.type);
      if (this.productState.type === '1') {
        this.luaErrorLogDialog = true;
        this.getLuaErrorLogList();
      } else if (this.productState.type === '2') {
        this.suin = '';
        this.studioLogPageInfo.page = 1;
        this.studioLogDialog = true;
        this.getStudioLogList();
      }
    },
    handleSearchStudioLog() {
      this.studioLogPageInfo.page = 1;
      this.getStudioLogList();
    },
    getLuaErrorLogList() {
      try {
        this.luaErrorLogLoading = true;
        const params = {
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
        };
        getSsLuaErrorData(params).then(res => {
          if (res.code === 0) {
            this.luaErrorLogList = res.data.list.map(item => {
              return {
                ...item,
                ellipsis: true,
              };
            });
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.luaErrorLogLoading = false;
      }
    },
    async getStudioLogList() {
      try {
        const params = {
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
          ...this.studioLogPageInfo
        };
        if (this.suin) {
          params.suin = this.suin;
        }
        this.studioLogLoading = true;
        const res = await getStudioMapLogFiles(params);
        this.studioLogLoading = false;
        if (res.code !== 0) {
          return;
        }
        this.studioLogList = res.data.list;
        this.studioLogPageInfo.total = res.data.total;
      } catch (error) {
        console.log(error);
      } finally {
        this.studioLogLoading = false;
      }
    },
    selectChange(val) {
      this.productState.type = val;
    },
    clickDate() {
      const nowTime = new Date(new Date(new Date()).toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      this.endTime =
        new Date(new Date(new Date()).toDateString()).getTime() - 1;
      // this.query.selectDate[1] = this.endTime - ONE_DAY_TIME;
      if (this.dayNum == 2) {
        this.startTime = nowTime - 48 * 60 * 60 * 1000;
      } else if (this.dayNum == 7) {
        this.startTime = nowTime - 7 * 24 * 60 * 60 * 1000;
      } else if (this.dayNum == 14) {
        this.startTime = nowTime - 14 * 24 * 60 * 60 * 1000;
      } else {
        this.startTime = nowTime - 24 * 60 * 60 * 1000;
      }
      this.query.selectDate[0] = formatDate(this.startTime);
      // this.query.selectDate[1] = formatDate(this.endTime);
      // this.getLuaErrorLogList();
      this.handleSearch();
    },
    async exportFn() {
      // TODO: 导出数据
      htmlToExcel.getExcel('#ssLuaErrLog', 'ss_lua_error日志');
    },
    async sdudioDownload(row) {
      try {
        const params1 = {
          aid: this.appId || this.mapId,
          startTime: this.query.selectDate[0],
          endTime: this.query.selectDate[1],
          filename: row.filename
        };
        this.studioLogLoading = true;
        const res1 = await studioMapPreDownload(params1);
        this.studioLogLoading = false;
        if (res1.code !== 0) {
          return;
        }
        const params2 = {
          url: res1.data.downloadurl,
          token: res1.data.token,
          filename: row.filename
        };
        this.studioLogLoading = true;
        const res2 = await studioMapDownload(params2);
        this.studioLogLoading = false;
        if (res2.status !== 200) {
          this.$message.error('下载失败');
          return;
        }
        const { data, headers } = res2;
        const blob = new Blob([data], { type: headers['content-type'] });
        const dom = document.createElement('a');
        const downUrl = window.URL.createObjectURL(blob);
        dom.href = downUrl;
        dom.download = decodeURIComponent(row.filename);
        dom.style.display = 'none';
        document.body.appendChild(dom);
        dom.click();
        dom.parentNode.removeChild(dom);
        window.URL.revokeObjectURL(downUrl);
        this.$message.success('下载成功');
      } catch (error) {
        console.error(error);
        this.studioLogLoading = false;
      }
    },
    CurrentChange(currPage) {
      this.studioLogPageInfo.page = currPage;
      this.getStudioLogList();
    },
  },
};
</script>

<style lang="scss" scoped>
#map_log_data {
  margin-bottom: 30px;
}
.search_btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
  color: #595959;
  border-right: 1px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;
  background-color: #f4f4f5;
  margin-right: 20px;
}
.btnGroup {
  margin-bottom: 15px;
}
.data-box {
  margin-top: 20px;
}
.download-wrap {
  // float: right;
  border-radius: 4px;
  font-size: 11px;
  // font-weight: 600;
  margin-top: 18px;
  margin-left: 20px;
  // display: flex;
  align-items: center;
  cursor: pointer;
  color: #2b6ddf;
  img {
    margin-right: 8px;
  }
}
.mgr25 {
  margin-right: 25px;
}
</style>
